import { CSSProperties, ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface TrProps {
  fullWidth?: boolean;
  borderBottom?: boolean;
  borderTop?: boolean;
  children?: ReactNode;
}

interface ThProps {
  lines?: number;
  hasRowSelection?: boolean;
  style?: CSSProperties;
  children?: ReactNode;
}

export const Tr = styled.div<TrProps>`
  background: ${({ theme }) => theme.palette.backgrounds.columnHeader};
  padding: 0 25px;

  ${({ fullWidth }) =>
    !fullWidth &&
    css`
      width: fit-content;
    `}

  ${({ borderBottom, theme }) =>
    borderBottom &&
    css`
      border-bottom: ${`1px solid ${theme.palette.tableBorderColor}`};
    `}

  ${({ borderTop, theme }) =>
    borderTop &&
    css`
      border-top: ${`1px solid ${theme.palette.tableBorderColor}`};
    `}
`;

export const Th = styled.div<ThProps>`
  border-bottom: none;
  font:
    400 16px 'Open Sans',
    sans-serif;
  letter-spacing: 0.02em;
  padding: ${({ lines }) => (lines == 2 ? 12 : 25)}px 15px;
  text-align: right;
  text-transform: uppercase;
  white-space: nowrap;
  display: inline-block;
  text-align: left;
  vertical-align: top;
  flex: 150 1 0%;

  :first-child {
    ${({ hasRowSelection }) =>
      hasRowSelection &&
      css`
        width: 30px !important;
        min-width: 30px !important;
        flex: 30 0 auto;
      `}
  }

  ${({ style }) =>
    style &&
    css`
      flex: ${`${style.width} 0 auto`};
    `}
`;
